import { useQuery } from "@tanstack/react-query";
import { GetPartnerConnectionsResponse } from "api/client.generated";
import useApi from "../useApi";

interface UseSourcePartnerConnectionsReturn {
  sourcePartnerConnections: GetPartnerConnectionsResponse | undefined;
  isSourcePartnerConnectionsFetching: boolean;
}

const useSourcePartnerConnections = (): UseSourcePartnerConnectionsReturn => {
  const { partnersMigrationClient } = useApi();

  const { data, isFetching } = useQuery({
    queryKey: ["getSourcePartnerConnections"],
    queryFn: () => partnersMigrationClient.getSourcePartnerConnections(),
  });

  return { sourcePartnerConnections: data, isSourcePartnerConnectionsFetching: isFetching };
};

export default useSourcePartnerConnections;
